import { FireTruckOutlined } from '@mui/icons-material';
import { Card, Space } from 'antd';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { getDeliverCollection } from '../../dashboardActions';
import dayjs from 'dayjs';

const OrdersActivity = ({ height = 350 }) => {
    const [categories, setCategories] = useState([]);
    const [series, setSeries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDeliverCollection().then((data) => {
            if (data?.ack) {
                const filteredData = data?.items_expiry?.filter(item =>
                    item.order_type === 'delivery' || item.order_type === 'collection'
                );

                const datesSet = new Set(filteredData.map(item => item.posted_at));
                const sortedDates = Array.from(datesSet).sort();

                const orderTypes = ['delivery', 'collection'];

                const dateTypeMap = {};
                filteredData.forEach(item => {
                    const key = `${item.posted_at}_${item.order_type}`;
                    dateTypeMap[key] = item.total_orders;
                });

                const chartSeries = orderTypes.map(type => {
                    const dataPoints = sortedDates.map(date => {
                        const key = `${date}_${type}`;
                        return dateTypeMap[key] || 0;
                    });
                    return {
                        name: type.charAt(0).toUpperCase() + type.slice(1),
                        data: dataPoints,
                    };
                });

                const chartCategories = sortedDates.map(date =>
                    dayjs(date).format('ddd')
                );

                setSeries(chartSeries);
                setCategories(chartCategories);
            }
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const options = {
        chart: {
            type: 'bar',
            height,
            toolbar: { show: false },
            background: 'transparent',
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '60%',
                borderRadius: 6,
            },
        },
        dataLabels: { enabled: false },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories,
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            title: { text: 'Orders' },
        },
        fill: { opacity: 1 },
        tooltip: {
            y: {
                formatter: (val) => `${val} Orders`,
            },
        },
        colors: ['#FF6B6B', '#4ECDC4'],
        legend: {
            position: 'top',
            horizontalAlign: 'left',
        },
        grid: {
            borderColor: '#f1f1f1',
            strokeDashArray: 4,
        },
    };

    return (
        <Card
            title={
                <Space>
                    <FireTruckOutlined style={{ color: '#05A1A4' }} />
                    <span style={{ fontWeight: 600 }}>Delivery / Collection Orders</span>
                </Space>
            }
            styles={{
                header: { background: '#f5f5f5' },
                body: { padding: '24px' }
            }}
            style={{
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                border: '1px solid #f0f0f0',
                height: '100%',
                minHeight: height
            }}
            loading={loading}
        >
            <Chart options={options} series={series} type="bar" height={height} />
        </Card>
    );
};

export default OrdersActivity;